import React, { FC, useState } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { Box, Typography } from 'transfix-ui/core'
import { SubtitleComponentDispatchModal } from './SubtitleComponentDispatchModal'

/**
 * Displays a ELD message which opens a confirmation modal to dispatch the load.
 */
export const SubtitleComponentDispatch: FC = () => {
  const [isDispatchModalOpen, setIsDispatchModalOpen] = useState(false)
  const openDispatchModalHandler = () => setIsDispatchModalOpen(true)
  const closeDispatchModalHandler = () => setIsDispatchModalOpen(false)
  return (
    <Box>
      <Box>
        <Button onClick={openDispatchModalHandler} className='btn-text-link-b'>
          Mark this load as Dispatched
        </Button>{' '}
        <Typography variant='subtitle2' component='span'>
          to see tracking and ETA updates.
        </Typography>
      </Box>
      <SubtitleComponentDispatchModal
        onClose={closeDispatchModalHandler}
        open={isDispatchModalOpen}
      />
    </Box>
  )
}
